/* ================================================================ */
// MAP REDUCER | Map/index.js
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
//import update from "react-addons-update";
//import {FlyToInterpolator} from 'deck.gl';
import * as MapActions from '../../actions/Map';
import {MapController, COORDINATE_SYSTEM} from '@deck.gl/core';
import GL from '@luma.gl/constants';
/* ========================================== */
// Reducer
/* ========================================== */
export default function reducer(
    state = {
        // Loading State
        loading: {
            map: true,
            style: true,
            layers: true,
            classes: false
        },
        // Current State
        state: 'default',
        // Mapping Types
        type: 'deckgl',
        // View State
        viewState: {
            "destination": {
                "x": -5002965.10882716,
                "y": 2519368.2360078953,
                "z": -3083740.637290964
            },
            "duration": 10,
            "orientation": {
                "heading": 1.1542992823390623,
                "pitch": -0.5273718484770713,
                "roll": 6.280199761841466
            }
        },
        // JSON Config
        jsonConfig: {
            //classes: Object.assign({}, require('@deck.gl/layers'), require('@deck.gl/aggregation-layers')),
            constants: {
                MapController
            },
            // a map of all layers that should be exposes as JSONLayers
            layers: {...require('@deck.gl/layers')},
            // Any non-standard views
            views: {},
            // Enumerations that should be available to JSON parser
            // Will be resolved as `<enum-name>.<enum-value>`
            enumerations: {
                COORDINATE_SYSTEM,
                GL
            }
        },
        // Layer Classes
        layerClasses: {
            ...require('@deck.gl/layers'),
            IconClusterLayer: require('@myglobe/core/dist/Map/layers/IconClusterLayer').default
        },
        /*loadedLayers: {
            deckLayers: [],
            mapboxLayers: [],
            markers: []
        },
        // Loaded Layers
        deckLayers: [],*/
        loadedLayers: [
            /*'shipping',
            'field-compression-stations',
            'water-treatment',
            'central-processing',
            'export-pipeline',
            'collection-header',
            'gea-members',
            'gladstone-lga',
            'gladstone-port',
            'qclng-plant',
            'qgc-pl',
            'qsc_extracted_data',
            'gladstone-land-use'*/
        ],

        // Loaded Layer Objects
        deckLayers: [],
        mapboxLayers: [],
        markers: [],
        // Current Layer Ids
        layers: [],
        // Style
        mapStyle: null,
        spriteJSON: [],
        spriteImage: [],
        // Map Base Config
        mapboxToken: null,
        mapboxUserId: 'ifeviser',
        baseMapStyle: null

    }, action) {
    switch (action.type) {
    /* ======================== */
    // DECKGL CONFIG
    /* ======================== */
    case MapActions.UPDATE_DECK_LAYER_CLASSES: { return {...state, loading: {...state.loading, deckConfig: true}}; }
    case MapActions.UPDATE_DECK_LAYER_CLASSES_SUCCESS: { return {...state, layerClasses: {...state.layerClasses, ...action.payload}, loading: {...state.loading, deckConfig: false}}; }
    case MapActions.UPDATE_DECK_LAYER_CLASSES_FAILURE: { return {...state, error: action.error, loading: {...state.loading, deckConfig: false}}; }
    /* ======================== */
    // CONFIG
    /* ======================== */
    case MapActions.UPDATE_MAP_CONFIG: { return {...state, loading: {...state.loading, map: true}}; }
    case MapActions.UPDATE_MAP_CONFIG_SUCCESS: {
        const {mapboxUserId, mapboxToken} = action.payload;
        return {...state, mapboxUserId, mapboxToken, loading: {...state.loading, map: false}};
    }
    case MapActions.UPDATE_MAP_CONFIG_FAILURE: { return {...state, error: action.error, loading: {...state.loading, map: false}}; }
    case MapActions.UPDATE_MAP_TILES_LOADED: { return {...state, loading: {...state.loading, map: false}}};
    /* ======================== */
    // VIEW STATE
    /* ======================== */
    case MapActions.UPDATE_MAP_VIEW_STATE: {
        // Default to existing state parameters on unused keys

        let updatedMapView = {...state.viewState};
        Object.keys(action.payload).forEach(key=>updatedMapView[key] = action.payload[key]);
        return {...state, viewState: updatedMapView};
    }
    /* ======================== */
    // MAP STYLES
    /* ======================== */
    case MapActions.UPDATE_MAP_STYLES: { return {...state, loading: {...state.loading, style: true }}; }
    case MapActions.UPDATE_MAP_STYLES_SUCCESS: { return {...state, mapStyle: action.payload.style, spriteJSON: action.payload.spriteJSON, spriteImage: action.payload.spriteImage, loading: {...state.loading, style: false }}; }
    case MapActions.UPDATE_MAP_STYLES_FAILURE: { return {...state, error: action.error, loading: {...state.loading, style: false }}; }
    /* ======================== */
    // VIS LAYERS
    /* ======================== */
    case MapActions.UPDATE_MAP_LAYERS: { return {...state, loading: {...state.loading, layers: true}}; }
    case MapActions.UPDATE_MAP_LAYERS_SUCCESS: {
        // Get current layers
        const layers = action.payload.layers || [];

        // Check for new layers
        if(action.payload.deckLayers || action.payload.mapboxLayers || action.payload.markers) {
            // New layers
            const newDeckLayers = action.payload.deckLayers || [];
            const newMapboxLayers = action.payload.mapboxLayers || [];
            const newMarkers = action.payload.markers || [];

            // Merge new layers into loaded layers
            const deckLayers = [...state.deckLayers, ...newDeckLayers];
            const mapboxLayers = [...state.mapboxLayers, ...newMapboxLayers];
            const markers = [...state.markers, ...newMarkers];

            // Update current layers and loaded layers
            return {...state, layers, deckLayers, mapboxLayers, markers, loading: {...state.loading, layers: false}};

        } else {
            // Update current layers
            return {...state, layers, loading: {...state.loading, layers: false}};
        }
    }
    case MapActions.UPDATE_MAP_LAYERS_FAILURE: { return {...state, error: action.error, loading: {...state.loading, layers: false}}; }
    /* ======================== */
    // MAP STATE FAILURE
    /* ======================== */
    case MapActions.UPDATE_MAP_STATE_FAILURE: {return {...state, error: action.error}; }
    /* ======================== */
    // LAYER CLASSES
    /* ======================== */
    case MapActions.UPDATE_LAYER_CLASSES: {return {...state, layerClasses: {...state.layerClasses, ...action.payload}, loading: {...state.loading, classes: false}}; }
    }
    return state;
}